import { ApiCompany } from "./company.model";
import { ApiContact } from "./contact.model";
import { ApiModel } from "./model.model";

export class ApiOpportunity extends ApiModel {
    Company: ApiCompany;
    Contact: ApiContact;
    company_ID: string;
    company_name: string;
    contact_ID: string;
    contact_firstname: string;
    contact_lastname: string;
    name: string;
    type: string;
    sub_type: string;
    record_type: string;
    lead_source: string;
    lead_source_detail: string;
    estimated_units: string;
    estimated_value: string;
    estimated_units2: string;
    estimated_value2: string;
    estimated_units3: string;
    estimated_value3: string;
    estimated_units4: string;
    estimated_value4: string;
    close_date: string;
    call_back_date: string;
    call_back_type: string;
    converted_date: string;
    probability: string;
    stage: string;
    status_reason: string;
    status_reason_description: string;
    notes: string;
    time_to_first_act: string;
    search_other_flag: string;
    status: string;
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/opportunity.model.ts